import EnviromentHelper from "./ignoreCoverage/KitchenHelper/EnviromentHelper";
export {EnviromentHelper}

import {DefaultTranslator} from "./ignoreCoverage/KitchenHelper/translations/DefaultTranslator";
export {DefaultTranslator}

import {CookieDetails, CookieGroupEnum} from "./ignoreCoverage/KitchenHelper/screens/legalRequirements/CookieHelper";
export {CookieDetails}
export {CookieGroupEnum}

import {useMyContrastColor} from "./ignoreCoverage/KitchenHelper/theme/useMyContrastColor";
export {useMyContrastColor}

import {HeaderWithActions} from "./ignoreCoverage/KitchenHelper/templates/HeaderWithActions";
export {HeaderWithActions}

import {TranslationKeys} from "./ignoreCoverage/KitchenHelper/translations/TranslationKeys";
export {TranslationKeys}

import {RequiredSettingsButton} from "./ignoreCoverage/KitchenHelper/screens/settings/RequiredSettingsButton";
export {RequiredSettingsButton}

import {LegalRequiredInternalLink} from "./ignoreCoverage/KitchenHelper/screens/legalRequirements/LegalRequiredInternalLink";
export {LegalRequiredInternalLink}

import {LegalRequiredLinks} from "./ignoreCoverage/KitchenHelper/screens/legalRequirements/LegalRequiredLinks";
export {LegalRequiredLinks}

import TextGenerator from "./ignoreCoverage/KitchenHelper/helper/TextGenerator";
export {TextGenerator}

import {BreakPointLayout} from "./ignoreCoverage/KitchenHelper/templates/BreakPointLayout";
export {BreakPointLayout}

import {NavigatorHelper} from "./ignoreCoverage/KitchenHelper/navigation/NavigatorHelper";
export {NavigatorHelper}

import {GridList} from "./ignoreCoverage/KitchenHelper/layouts/GridList";
export {GridList};

import {Navigation} from "./ignoreCoverage/KitchenHelper/navigation/Navigation";
export {Navigation}

import {useProjectColor} from "./ignoreCoverage/KitchenHelper/templates/useProjectColor";
export {useProjectColor}

import {ParentDimension} from "./ignoreCoverage/KitchenHelper/components/ParentDimension";
export {ParentDimension}

import {RequiredSynchedStates} from "./ignoreCoverage/KitchenHelper/synchedstate/RequiredSynchedStates";
export {RequiredSynchedStates}

import {BackButton} from "./ignoreCoverage/KitchenHelper/templates/BackButton";
export {BackButton}

import {DrawerButton} from "./ignoreCoverage/KitchenHelper/templates/DrawerButton";
export {DrawerButton}

import {MyActionsheet} from "./ignoreCoverage/KitchenHelper/helper/MyActionsheet";
export {MyActionsheet};

import {ScrollViewWithGradient} from "./ignoreCoverage/KitchenHelper/utils/ScrollViewWithGradient";
export {ScrollViewWithGradient};

import {AuthProviderCustom} from "./ignoreCoverage/KitchenHelper/auth/AuthProviderCustom";
export {AuthProviderCustom}

import {MyThemedBox, useThemedShade} from "./ignoreCoverage/KitchenHelper/helper/MyThemedBox";
export {MyThemedBox, useThemedShade}

import {ThemedMarkdown} from "./ignoreCoverage/KitchenHelper/components/markdown/ThemedMarkdown";
export {ThemedMarkdown}

import {DirectusMarkdown} from "./ignoreCoverage/KitchenHelper/components/markdown/DirectusMarkdown";
export {DirectusMarkdown}

import {DirectusSingletonMarkdown} from "./ignoreCoverage/KitchenHelper/components/markdown/DirectusSingletonMarkdown";
export {DirectusSingletonMarkdown}

import {DeviceHelper} from "./ignoreCoverage/KitchenHelper/helper/DeviceHelper";
export {DeviceHelper}

import {PlatformHelper} from "./ignoreCoverage/KitchenHelper/helper/PlatformHelper";
export {PlatformHelper}

import {KitchenSafeAreaView} from "./ignoreCoverage/KitchenHelper/components/KitchenSafeAreaView";
export {KitchenSafeAreaView}

import {Icon} from "./ignoreCoverage/KitchenHelper/components/Icon";
export {Icon}

import {EmptyTemplate} from "./ignoreCoverage/KitchenHelper/templates/EmptyTemplate";
export {EmptyTemplate}

import {MyDirectusStorage} from "./ignoreCoverage/KitchenHelper/storage/MyDirectusStorage";
export {MyDirectusStorage}

import {CrossLottie} from "./ignoreCoverage/KitchenHelper/components/CrossLottie";
export {CrossLottie}

import {DirectusImage} from "./ignoreCoverage/KitchenHelper/project/DirectusImage";
export {DirectusImage}

import {DirectusIcon} from "./ignoreCoverage/KitchenHelper/project/DirectusIcon";
export {DirectusIcon}

import {getDirectusImageUrl} from "./ignoreCoverage/KitchenHelper/project/DirectusImage";
export {getDirectusImageUrl}

import {Layout} from "./ignoreCoverage/KitchenHelper/templates/Layout";
export {Layout}

import CustomFloaters from "./ignoreCoverage/KitchenHelper/templates/CustomFloaters";
export {CustomFloaters}

import {KitchenSkeleton} from "./ignoreCoverage/KitchenHelper/project/KitchenSkeleton";
export {KitchenSkeleton}

import {RequiredStorageKeys} from "./ignoreCoverage/KitchenHelper/storage/RequiredStorageKeys";
export {RequiredStorageKeys}

import {useThemeTextColor} from "./ignoreCoverage/KitchenHelper/helper/HelperHooks";
export {useThemeTextColor}

import {useBackgroundColor} from "./ignoreCoverage/KitchenHelper/templates/useBackgroundColor";
export {useBackgroundColor}

import {
  SynchedState,
  useSynchedState,
  useSynchedJSONState,
  useSynchedDrawerConfig
} from "./ignoreCoverage/KitchenHelper/synchedstate/SynchedState";
export {useSynchedState}
export {SynchedState}
export {useSynchedJSONState}
export {useSynchedDrawerConfig}

import ServerAPI from "./ignoreCoverage/KitchenHelper/ServerAPI";
export {ServerAPI}

export function multiply(a: number, b: number): Promise<number> {
  return Promise.resolve(a * b);
}

import {BaseNoScrollTemplate} from "./ignoreCoverage/KitchenHelper/templates/BaseNoScrollTemplate";
export {BaseNoScrollTemplate}

import {BaseNoPaddingTemplate} from "./ignoreCoverage/KitchenHelper/templates/BaseNoPaddingTemplate";
export {BaseNoPaddingTemplate}

import {BasePadding} from "./ignoreCoverage/KitchenHelper/templates/BasePadding";
export {BasePadding}

import {BaseTemplate} from "./ignoreCoverage/KitchenHelper/templates/BaseTemplate";
export {BaseTemplate}

import {MenuItem} from "./ignoreCoverage/KitchenHelper/navigation/MenuItem";
export {MenuItem}

import {PluginInterface} from "./ignoreCoverage/KitchenHelper/PluginInterface";
export {PluginInterface}

import {TextWithIcon} from "./ignoreCoverage/KitchenHelper/components/TextWithIcon";
export {TextWithIcon};

import {ConfigHolder} from "./ignoreCoverage/KitchenHelper/ConfigHolder";
export {ConfigHolder}

import App from "./ignoreCoverage/KitchenHelper/App";
export {App}

import {Root} from "./ignoreCoverage/KitchenHelper/navigation/RootComponent";
export {Root}
